import isFinite from "lodash/isFinite";

const isValidId = (id) => isFinite(id) || /^\d+::\d+$/.test(id);

export default isValidId;
